import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TslSessionService } from 'projects/aztalena-core/src/public-api';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators';
import { AuthService } from '../auth.service';

@Injectable()
export class RefreshTokenInterceptor implements HttpInterceptor {
  private auth = inject(AuthService);
  private session = inject(TslSessionService);

  private refreshTokenInProgressSubject = new BehaviorSubject<boolean>(false);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (request.url.includes('/auth/sign-in')) {
          return throwError(() => err);
        } else if (request.url.includes('/auth/refresh-token')) {
          this.session.destroy();
          window.location.reload();
          return throwError(() => err);
        }
        if (err.status !== 401) {
          return throwError(() => err);
        }
        if (this.refreshTokenInProgressSubject.value) {
          return this.refreshTokenInProgressSubject.pipe(
            filter((x) => x === false),
            take(1),
            switchMap(() => next.handle(this.addAuthenticationToken(request)))
          );
        } else {
          this.refreshTokenInProgressSubject.next(true);
          return this.auth.refreshToken().pipe(
            switchMap((tokens) => {
              this.session.construct(tokens.access_token, tokens.refresh_token);
              this.refreshTokenInProgressSubject.next(false);
              return next.handle(this.addAuthenticationToken(request));
            }),
            catchError(() => {
              this.refreshTokenInProgressSubject.next(false);
              this.session.destroy();
              window.location.reload();
              return throwError(() => err);
            })
          );
        }
      })
    );
  }

  addAuthenticationToken(request: HttpRequest<any>): HttpRequest<any> {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${this.session.accessToken}`
      }
    });
  }
}
